import { type ReactNode } from "react";
import { cn } from "@strivelabs/ui-core";

export interface ComposerSurfaceProps {
  className?: string;
  children: ReactNode;
}

/**
 * The composer writing surface: a bordered card (shadcn tokens) that raises a
 * focus ring on focus-within so it reads as active while typing.
 */
export const ComposerSurface = ({
  className,
  children,
}: ComposerSurfaceProps) => (
  <div
    className={cn(
      "relative rounded-[22px] border border-border bg-card shadow-[0_2px_10px_-6px_rgba(0,0,0,0.08)]",
      "ring-1 ring-border/70 ring-offset-2 ring-offset-background",
      "transition-[border-color,box-shadow] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
      "hover:border-muted-foreground/40 hover:shadow-[0_4px_14px_-8px_rgba(0,0,0,0.10)]",
      "focus-within:border-muted-foreground/70 focus-within:shadow-[0_6px_18px_-8px_rgba(0,0,0,0.12)]",
      className,
    )}
  >
    {children}
  </div>
);
